/**
 * Only returns true when both set a and b match exactly
 */ const isExactMatch = (a, b)=>{
    const diff = new Set(a);
    for (const elem of b){
        if (diff.has(elem)) {
            diff.delete(elem);
        } else {
            return false;
        }
    }
    return diff.size <= 0;
};
const isMissing = (value)=>typeof value === 'undefined' || value === null || typeof value === 'object' && Object.getOwnPropertyNames(value).length < 1
;
/**
 * Server and client have a different way of expressing a missing value. With
 * this util we can easily catch this situation.
 */ function areBothMissing(server, client) {
    return isMissing(server) && isMissing(client);
}

export { areBothMissing, isExactMatch };
//# sourceMappingURL=shared.js.map
